import { CurrencyGet, Ulid } from "@kase/my-marathon-communication";
import { computed } from "@preact/signals";
import { dateToApi } from "~/utils";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Currency } from "./interfaces";

const MAX_COMPACT_AMOUNT = 16;

export const makeCurrency = ({ connection, company }: ApiSliceParams) => {
    const {
        items: currencies,
        get,
        listen,
        allLoading: loading,
        allLoaded: loaded,
    } = createListController<CurrencyGet, Currency>({
        name: "currency",
        connection,
        list: (con) => con.currency.items(),
    });
    const base = computed(
        () =>
            currencies.value.find(
                (i) => i.code === connection.value?.user.base_currency,
            ) ?? null,
    );
    const compact = computed(
        () => currencies.value.length <= MAX_COMPACT_AMOUNT,
    );

    const rate = async (id: Readonly<Ulid>, date?: Date) => {
        const con = connection.value;
        const result = await con.currency.rate({
            id,
            company: company.value,
            date: date ? dateToApi(date) : undefined,
        });

        return result.rate?.toNumber();
    };

    const getByCode = (code: string) =>
        currencies.peek().find((i) => i.code === code) ?? null;

    return {
        base,
        currencies,
        loading,
        loaded,
        compact,
        listen,
        get,
        getByCode,
        rate,
    };
};
